var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPause1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50008 4.50007C9.50008 3.11934 8.38077 2.00003 7.00004 2.00003C5.61931 2.00003 4.5 3.11934 4.5 4.50007V19.5001C4.5 20.8808 5.61931 22.0001 7.00004 22.0001C8.38077 22.0001 9.50008 20.8808 9.50008 19.5001V4.50007ZM19.5001 4.50007C19.5001 3.11934 18.3808 2.00003 17 2.00003C15.6193 2.00003 14.5 3.11934 14.5 4.50007V19.5001C14.5 20.8808 15.6193 22.0001 17 22.0001C18.3808 22.0001 19.5001 20.8808 19.5001 19.5001V4.50007Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPause1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Pause1.da2ccde4ecaadc3d78213ea0d99d0f37.svg";